import React, { ComponentPropsWithoutRef, FC } from 'react';

import { useTheme } from '@mui/material';

import { Svg } from '~/assets/icons/styles';

const ChatBotSadIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => {
  const theme = useTheme();

  return (
    <Svg
      width="38"
      height="37"
      viewBox="0 0 38 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      svgColor={theme.palette.common.primary}
      {...props}
    >
      <path
        d="M1.0692 24.2558C1.29388 22.1535 0.0571518 17.6402 3.29265 17.3432C2.51503 20.2036 2.85891 24.2831 3.3962 26.6882C2.10279 26.6277 1.07115 25.5609 1.07115 24.2577L1.0692 24.2558ZM34.4655 26.7058C34.1294 28.1692 33.5433 29.5701 32.7716 30.6584H32.7696C29.1609 35.664 22.0159 35.8574 16.1486 35.5722C10.5881 35.3221 4.82247 32.9424 3.531 27.163C2.86476 24.5195 2.50524 20.4263 3.31411 17.3237C5.04909 10.5284 11.9597 5.90762 18.9426 6.0014C25.9235 5.90762 32.8302 10.5245 34.5691 17.3178C35.3584 20.2016 35.0106 24.2773 34.4674 26.7058H34.4655ZM36.9332 24.2558C36.9332 25.598 35.8351 26.6922 34.487 26.6902C35.0263 24.2733 35.3721 20.2075 34.5906 17.3354C37.957 17.5054 36.7163 22.1339 36.9332 24.2577V24.2558ZM34.5847 17.3178C30.5052 2.30873 7.36437 2.32045 3.29656 17.3256C0.0395712 17.6168 1.27437 22.1476 1.05164 24.2558C1.05164 25.5687 2.09302 26.6433 3.39816 26.7039C4.57044 32.8154 10.3185 35.3143 16.1486 35.5898C22.0178 35.875 29.1649 35.6816 32.7794 30.676H32.7813C33.559 29.5818 34.1451 28.177 34.4831 26.7058C35.841 26.7097 36.9488 25.6097 36.9488 24.2558C36.7339 22.1163 37.9726 17.4878 34.5847 17.3178Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.18539 25.2322C3.77475 18.349 6.39087 11.7685 13.1823 8.98242C13.1842 8.98438 14.8411 10.608 14.843 10.6099H23.0431L24.7058 8.98242C31.5031 11.7764 34.1114 18.347 32.7027 25.2322M32.6988 25.2517C32.1127 29.3528 29.2132 32.3284 25.0555 33.2174C19.0417 34.3662 9.57949 34.7062 6.25607 28.5185C5.72268 27.4966 5.39445 26.381 5.1893 25.2517M24.7078 8.9668H24.7019L23.0373 10.5963H14.8508L13.1882 8.96484C6.39674 11.708 3.73957 18.433 5.17366 25.2459C6.33617 33.5085 15.2924 34.3545 22.1463 33.7234C25.9348 33.3561 29.731 32.0881 31.55 28.7139C32.7047 26.594 33.0017 24.1146 33.0466 21.4965C33.3553 16.0669 29.7779 10.9909 24.7097 8.96874L24.7078 8.9668Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7629 31.3119C16.0814 31.3119 16.3608 31.1009 16.4253 30.8C16.6715 29.6453 17.7304 28.7758 19.0023 28.7758C20.2743 28.7758 21.3332 29.6453 21.5794 30.8C21.6439 31.1009 21.9233 31.3119 22.2417 31.3119C22.6735 31.3119 22.992 30.927 22.9041 30.5186C22.525 28.7759 20.9229 27.4688 19.0023 27.4688C17.0817 27.4688 15.4796 28.7778 15.1006 30.5186C15.0127 30.927 15.3311 31.3119 15.7629 31.3119Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25515 20.75C9.57362 20.75 9.85299 20.961 9.91747 21.2619C10.1636 22.4166 11.2226 23.286 12.4945 23.286C13.7664 23.286 14.8254 22.4166 15.0716 21.2619C15.1361 20.961 15.4155 20.75 15.7339 20.75C16.1657 20.75 16.4842 21.1349 16.3963 21.5433C16.0172 23.286 14.4151 24.5931 12.4945 24.5931C10.5739 24.5931 8.97182 23.2841 8.59278 21.5433C8.50486 21.1349 8.82336 20.75 9.25515 20.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2707 20.75C22.5892 20.75 22.8686 20.961 22.9331 21.2619C23.1793 22.4166 24.2382 23.286 25.5101 23.286C26.7821 23.286 27.841 22.4166 28.0872 21.2619C28.1517 20.961 28.4311 20.75 28.7496 20.75C29.1814 20.75 29.4998 21.1349 29.4119 21.5433C29.0328 23.286 27.4307 24.5931 25.5101 24.5931C23.5896 24.5931 21.9874 23.2841 21.6084 21.5433C21.5205 21.1349 21.8389 20.75 22.2707 20.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default ChatBotSadIcon;
